import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, useNavigate, useSearchParams } from 'react-router-dom';
import './App.css';

const HomePage = () => {
  const [games, setGames] = useState([]);
  const [filteredGames, setFilteredGames] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [currentCategory, setCurrentCategory] = useState('all');
  const navigate = useNavigate();

  useEffect(() => {
    // Load games from public/games.json
    fetch('/games.json')
      .then(res => res.json())
      .then(data => {
        setGames(data.games);
        setFilteredGames(data.games);
      })
      .catch(err => console.error('Error loading games:', err));
  }, []);

  useEffect(() => {
    filterGames();
  }, [searchTerm, currentCategory, games]);

  const filterGames = () => {
    let filtered = games;

    if (currentCategory !== 'all') {
      filtered = filtered.filter(game => game.category === currentCategory);
    }

    if (searchTerm) {
      filtered = filtered.filter(game =>
        game.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
        game.description.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    setFilteredGames(filtered);
  };

  const playGame = (slug) => {
    navigate(`/game?game=${slug}`);
  };

  return (
    <div className="min-h-screen" style={{ backgroundColor: '#222222', color: '#00FFCC', fontFamily: 'VT323, monospace' }}>
      {/* AdSense Placeholder Top */}
      <div className="w-full py-4 text-center" style={{ backgroundColor: '#1a1a1a', borderBottom: '2px solid #00FFCC' }}>
        <div style={{ color: '#FF0066', fontSize: '20px', fontFamily: 'VT323, monospace' }}>[ AdSense Placeholder - Top Banner 728x90 ]</div>
      </div>

      {/* Header */}
      <header className="py-8 px-4">
        <div className="max-w-6xl mx-auto text-center">
          <h1 style={{ fontFamily: 'Press Start 2P, monospace', fontSize: '3rem', textShadow: '0 0 10px #00FFCC, 0 0 20px #00FFCC, 0 0 30px #00FFCC' }} className="mb-4">
            🎮 ArcadeSimple
          </h1>
          <p style={{ fontFamily: 'VT323, monospace', fontSize: '2rem', textShadow: '0 0 10px #FF0066, 0 0 20px #FF0066, 0 0 30px #FF0066', color: '#FF0066' }}>
            Play Free Retro Games Instantly
          </p>
        </div>
      </header>

      {/* Search & Filter */}
      <section className="px-4 py-6">
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-col md:flex-row gap-4 items-center justify-between">
            <input
              type="text"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              placeholder="Search games..."
              className="px-4 py-3 rounded-lg w-full md:w-96"
              style={{
                backgroundColor: '#1a1a1a',
                border: '2px solid #00FFCC',
                color: '#00FFCC',
                fontFamily: 'VT323, monospace',
                fontSize: '20px',
                outline: 'none'
              }}
            />
            <div className="flex gap-2 flex-wrap justify-center">
              {['all', 'action', 'classic', 'puzzle'].map(category => (
                <button
                  key={category}
                  onClick={() => setCurrentCategory(category)}
                  className="px-4 py-2 rounded"
                  style={{
                    backgroundColor: currentCategory === category ? '#00FFCC' : '#2a2a2a',
                    border: '2px solid #00FFCC',
                    color: currentCategory === category ? '#222222' : '#00FFCC',
                    fontFamily: 'VT323, monospace',
                    fontSize: '18px',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease'
                  }}
                >
                  {category.charAt(0).toUpperCase() + category.slice(1)}
                </button>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Games Grid */}
      <main className="px-4 py-8">
        <div className="max-w-6xl mx-auto">
          {filteredGames.length === 0 ? (
            <div className="text-center py-12" style={{ color: '#FF0066', fontFamily: 'VT323, monospace', fontSize: '24px' }}>
              No games found. Try a different search or category.
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {filteredGames.map(game => (
                <div
                  key={game.slug}
                  className="rounded-lg overflow-hidden p-4"
                  style={{
                    background: 'linear-gradient(145deg, #2a2a2a, #1a1a1a)',
                    border: '2px solid #00FFCC',
                    transition: 'all 0.3s ease',
                    cursor: 'pointer'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-8px)';
                    e.currentTarget.style.borderColor = '#FF0066';
                    e.currentTarget.style.boxShadow = '0 0 20px #FF0066';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.borderColor = '#00FFCC';
                    e.currentTarget.style.boxShadow = 'none';
                  }}
                >
                  <img
                    src={game.thumbnail}
                    alt={game.title}
                    className="w-full h-48 object-cover rounded mb-4"
                    onError={(e) => {
                      e.target.src = `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect fill='%23333' width='400' height='300'/%3E%3Ctext x='50%25' y='50%25' dominant-baseline='middle' text-anchor='middle' fill='%2300FFCC' font-family='monospace' font-size='20'%3E${game.title}%3C/text%3E%3C/svg%3E`;
                    }}
                  />
                  <h2 style={{ fontFamily: 'Press Start 2P, monospace', fontSize: '16px', color: '#00FFCC' }} className="mb-2">
                    {game.title}
                  </h2>
                  <p style={{ fontFamily: 'VT323, monospace', fontSize: '16px', color: '#d1d5db' }} className="mb-3">
                    {game.description}
                  </p>
                  <div className="flex justify-between items-center">
                    <span className="px-3 py-1 rounded" style={{ backgroundColor: '#1f2937', color: '#FF0066', fontFamily: 'VT323, monospace', fontSize: '14px' }}>
                      {game.category}
                    </span>
                    <button
                      onClick={() => playGame(game.slug)}
                      className="px-6 py-2 rounded-lg"
                      style={{
                        background: 'linear-gradient(135deg, #00FFCC, #00CC99)',
                        color: '#222222',
                        fontFamily: 'VT323, monospace',
                        fontSize: '18px',
                        fontWeight: 'bold',
                        border: 'none',
                        cursor: 'pointer',
                        transition: 'all 0.3s ease'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.background = 'linear-gradient(135deg, #FF0066, #CC0052)';
                        e.currentTarget.style.color = '#ffffff';
                        e.currentTarget.style.transform = 'scale(1.05)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.background = 'linear-gradient(135deg, #00FFCC, #00CC99)';
                        e.currentTarget.style.color = '#222222';
                        e.currentTarget.style.transform = 'scale(1)';
                      }}
                    >
                      Play Now
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </main>

      {/* AdSense Placeholder Bottom */}
      <div className="w-full py-4 text-center mt-12" style={{ backgroundColor: '#1a1a1a', borderTop: '2px solid #00FFCC' }}>
        <div style={{ color: '#FF0066', fontFamily: 'VT323, monospace', fontSize: '20px' }}>[ AdSense Placeholder - Bottom Banner 728x90 ]</div>
      </div>

      {/* Footer */}
      <footer className="py-8 px-4 mt-12" style={{ borderTop: '2px solid #00FFCC' }}>
        <div className="max-w-6xl mx-auto text-center">
          <div className="flex justify-center gap-6 mb-4" style={{ fontFamily: 'VT323, monospace', fontSize: '20px' }}>
            <a href="#about" style={{ color: '#00FFCC', textDecoration: 'none', transition: 'color 0.3s' }}>
              About
            </a>
            <a href="#privacy" style={{ color: '#00FFCC', textDecoration: 'none', transition: 'color 0.3s' }}>
              Privacy
            </a>
            <a href="#contact" style={{ color: '#00FFCC', textDecoration: 'none', transition: 'color 0.3s' }}>
              Contact
            </a>
            <a href="/admin" style={{ color: '#FF0066', textDecoration: 'none', transition: 'color 0.3s' }}>
              Admin
            </a>
          </div>
          <p style={{ fontFamily: 'VT323, monospace', fontSize: '18px', color: '#9ca3af' }}>
            © 2025 ArcadeSimple.com | Open Source (MIT License) | Made with 💚 for retro gaming
          </p>
        </div>
      </footer>
    </div>
  );
};

const GamePage = () => {
  const [searchParams] = useSearchParams();
  const [game, setGame] = useState(null);
  const navigate = useNavigate();
  const gameSlug = searchParams.get('game');

  useEffect(() => {
    if (gameSlug) {
      fetch('/games.json')
        .then(res => res.json())
        .then(data => {
          const foundGame = data.games.find(g => g.slug === gameSlug);
          if (foundGame) {
            setGame(foundGame);
          } else {
            alert('Game not found!');
            navigate('/');
          }
        })
        .catch(err => {
          console.error('Error loading game:', err);
          alert('Error loading game!');
          navigate('/');
        });
    } else {
      alert('No game specified!');
      navigate('/');
    }
  }, [gameSlug, navigate]);

  const toggleFullscreen = () => {
    const gameFrame = document.getElementById('gameFrame');
    if (gameFrame) {
      if (!document.fullscreenElement) {
        gameFrame.requestFullscreen().catch(err => {
          alert(`Error enabling fullscreen: ${err.message}`);
        });
      } else {
        document.exitFullscreen();
      }
    }
  };

  if (!game) {
    return (
      <div style={{ backgroundColor: '#222222', minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#00FFCC', fontFamily: 'VT323, monospace', fontSize: '24px' }}>
        Loading game...
      </div>
    );
  }

  return (
    <div className="min-h-screen" style={{ backgroundColor: '#222222', color: '#00FFCC', fontFamily: 'VT323, monospace' }}>
      {/* Header */}
      <header className="py-4 px-4" style={{ borderBottom: '2px solid #00FFCC' }}>
        <div className="max-w-7xl mx-auto flex justify-between items-center">
          <button
            onClick={() => navigate('/')}
            className="px-6 py-3 rounded-lg"
            style={{
              background: 'linear-gradient(135deg, #FF0066, #CC0052)',
              color: '#ffffff',
              fontFamily: 'VT323, monospace',
              fontSize: '20px',
              fontWeight: 'bold',
              border: 'none',
              cursor: 'pointer'
            }}
          >
            ← Back to Games
          </button>
          <h1 style={{ fontFamily: 'Press Start 2P, monospace', fontSize: '20px', color: '#00FFCC' }}>
            {game.title}
          </h1>
          <button
            onClick={toggleFullscreen}
            className="px-6 py-3 rounded-lg"
            style={{
              background: 'linear-gradient(135deg, #00FFCC, #00CC99)',
              color: '#222222',
              fontFamily: 'VT323, monospace',
              fontSize: '20px',
              fontWeight: 'bold',
              border: 'none',
              cursor: 'pointer'
            }}
          >
            Fullscreen
          </button>
        </div>
      </header>

      {/* AdSense Placeholder */}
      <div className="w-full py-3 text-center" style={{ backgroundColor: '#1a1a1a', borderBottom: '2px solid #FF0066' }}>
        <div style={{ color: '#FF0066', fontFamily: 'VT323, monospace', fontSize: '18px' }}>[ AdSense Placeholder - Game Page Banner 728x90 ]</div>
      </div>

      {/* Game Container */}
      <main className="px-4 py-6">
        <div className="max-w-7xl mx-auto">
          <div
            id="gameFrame"
            className="w-full"
            style={{
              height: '70vh',
              background: '#1a1a1a',
              border: '3px solid #00FFCC',
              boxShadow: '0 0 20px #00FFCC'
            }}
          >
            <iframe
              src={`/games/${game.slug}/index.html`}
              width="100%"
              height="100%"
              style={{ border: 'none', display: 'block' }}
              allowFullScreen
              title={game.title}
            />
          </div>
          <div className="mt-6 text-center">
            <p style={{ fontFamily: 'VT323, monospace', fontSize: '20px', color: '#d1d5db' }}>
              {game.description}
            </p>
          </div>
        </div>
      </main>
    </div>
  );
};

const AdminPage = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [password, setPassword] = useState('');
  const [formData, setFormData] = useState({
    title: '',
    slug: '',
    description: '',
    category: 'action',
    thumbnail: ''
  });
  const [jsonOutput, setJsonOutput] = useState('');
  const [showOutput, setShowOutput] = useState(false);
  const navigate = useNavigate();

  const ADMIN_PASSWORD = 'change-me-arcade';

  const checkPassword = () => {
    if (password === ADMIN_PASSWORD) {
      setIsAuthenticated(true);
    } else {
      alert('Incorrect password!');
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const gameData = {
      slug: formData.slug.trim(),
      title: formData.title.trim(),
      description: formData.description.trim(),
      category: formData.category,
      thumbnail: formData.thumbnail.trim()
    };
    const jsonString = JSON.stringify(gameData, null, 2);
    setJsonOutput(jsonString);
    setShowOutput(true);
  };

  const copyJSON = () => {
    navigator.clipboard.writeText(jsonOutput).then(() => {
      alert('JSON copied to clipboard! ✓\n\nNow add this entry to the "games" array in games.json');
    }).catch(err => {
      console.error('Failed to copy:', err);
      alert('Failed to copy. Please select and copy manually.');
    });
  };

  if (!isAuthenticated) {
    return (
      <div className="min-h-screen p-4" style={{ backgroundColor: '#222222' }}>
        <div className="max-w-md mx-auto mt-20">
          <div className="p-8 rounded-lg" style={{ background: '#1a1a1a', border: '3px solid #FF0066', boxShadow: '0 0 20px #FF0066' }}>
            <h1 style={{ fontFamily: 'Press Start 2P, monospace', fontSize: '24px', color: '#FF0066', textAlign: 'center' }} className="mb-6">
              🔒 Admin Access
            </h1>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              onKeyPress={(e) => e.key === 'Enter' && checkPassword()}
              placeholder="Enter admin password"
              className="w-full px-4 py-3 rounded-lg mb-4"
              style={{
                backgroundColor: '#2a2a2a',
                border: '2px solid #00FFCC',
                color: '#00FFCC',
                fontFamily: 'VT323, monospace',
                fontSize: '20px',
                outline: 'none'
              }}
            />
            <button
              onClick={checkPassword}
              className="w-full px-6 py-3 rounded-lg"
              style={{
                background: 'linear-gradient(135deg, #00FFCC, #00CC99)',
                color: '#222222',
                fontFamily: 'VT323, monospace',
                fontSize: '20px',
                fontWeight: 'bold',
                border: 'none',
                cursor: 'pointer'
              }}
            >
              Login
            </button>
            <p style={{ textAlign: 'center', color: '#9ca3af', fontFamily: 'VT323, monospace', fontSize: '14px' }} className="mt-4">
              Default password: change-me-arcade<br />
              (Change in admin page code)
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen p-4" style={{ backgroundColor: '#222222' }}>
      <div className="max-w-4xl mx-auto mt-10">
        <div className="p-8 rounded-lg" style={{ background: '#1a1a1a', border: '3px solid #FF0066', boxShadow: '0 0 20px #FF0066' }}>
          <div className="flex justify-between items-center mb-6">
            <h1 style={{ fontFamily: 'Press Start 2P, monospace', fontSize: '24px', color: '#FF0066' }}>Admin Panel</h1>
            <button
              onClick={() => navigate('/')}
              style={{ color: '#00FFCC', fontFamily: 'VT323, monospace', fontSize: '20px', background: 'none', border: 'none', cursor: 'pointer' }}
            >
              ← Back to Site
            </button>
          </div>

          <div className="p-4 rounded-lg mb-6" style={{ backgroundColor: '#78350f', border: '2px solid #92400e' }}>
            <p style={{ fontFamily: 'VT323, monospace', fontSize: '18px', color: '#fcd34d' }}>
              ⚠️ <strong>Static Site Note:</strong> This admin interface shows you how to structure game entries.
              To add games on static hosting, manually edit <code>games.json</code> and upload your game folder to <code>/games/your-game-slug/</code>.
              See README.md for full instructions.
            </p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block mb-2" style={{ fontFamily: 'VT323, monospace', fontSize: '20px', color: '#00FFCC' }}>Game Title</label>
              <input
                type="text"
                value={formData.title}
                onChange={(e) => setFormData({ ...formData, title: e.target.value })}
                required
                className="w-full px-4 py-2 rounded"
                placeholder="e.g., Flappy Bird"
                style={{
                  backgroundColor: '#2a2a2a',
                  border: '2px solid #00FFCC',
                  color: '#00FFCC',
                  fontFamily: 'VT323, monospace',
                  fontSize: '18px'
                }}
              />
            </div>

            <div>
              <label className="block mb-2" style={{ fontFamily: 'VT323, monospace', fontSize: '20px', color: '#00FFCC' }}>Game Slug (URL-friendly)</label>
              <input
                type="text"
                value={formData.slug}
                onChange={(e) => setFormData({ ...formData, slug: e.target.value })}
                required
                className="w-full px-4 py-2 rounded"
                placeholder="e.g., flappy-bird"
                style={{
                  backgroundColor: '#2a2a2a',
                  border: '2px solid #00FFCC',
                  color: '#00FFCC',
                  fontFamily: 'VT323, monospace',
                  fontSize: '18px'
                }}
              />
            </div>

            <div>
              <label className="block mb-2" style={{ fontFamily: 'VT323, monospace', fontSize: '20px', color: '#00FFCC' }}>Description</label>
              <textarea
                value={formData.description}
                onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                required
                rows={3}
                className="w-full px-4 py-2 rounded"
                placeholder="Brief description of the game"
                style={{
                  backgroundColor: '#2a2a2a',
                  border: '2px solid #00FFCC',
                  color: '#00FFCC',
                  fontFamily: 'VT323, monospace',
                  fontSize: '18px'
                }}
              />
            </div>

            <div>
              <label className="block mb-2" style={{ fontFamily: 'VT323, monospace', fontSize: '20px', color: '#00FFCC' }}>Category</label>
              <select
                value={formData.category}
                onChange={(e) => setFormData({ ...formData, category: e.target.value })}
                required
                className="w-full px-4 py-2 rounded"
                style={{
                  backgroundColor: '#2a2a2a',
                  border: '2px solid #00FFCC',
                  color: '#00FFCC',
                  fontFamily: 'VT323, monospace',
                  fontSize: '18px'
                }}
              >
                <option value="action">Action</option>
                <option value="classic">Classic</option>
                <option value="puzzle">Puzzle</option>
              </select>
            </div>

            <div>
              <label className="block mb-2" style={{ fontFamily: 'VT323, monospace', fontSize: '20px', color: '#00FFCC' }}>Thumbnail URL</label>
              <input
                type="text"
                value={formData.thumbnail}
                onChange={(e) => setFormData({ ...formData, thumbnail: e.target.value })}
                required
                className="w-full px-4 py-2 rounded"
                placeholder="e.g., games/flappy-bird/thumb.png"
                style={{
                  backgroundColor: '#2a2a2a',
                  border: '2px solid #00FFCC',
                  color: '#00FFCC',
                  fontFamily: 'VT323, monospace',
                  fontSize: '18px'
                }}
              />
            </div>

            <div className="p-4 rounded-lg" style={{ backgroundColor: '#1e3a8a', border: '2px solid #3b82f6' }}>
              <p style={{ fontFamily: 'VT323, monospace', fontSize: '18px', color: '#93c5fd' }}>
                📁 <strong>Manual Steps Required:</strong><br />
                1. Create folder: <code>/games/your-slug/</code><br />
                2. Add <code>index.html</code> (your game) inside<br />
                3. Add thumbnail image<br />
                4. Copy the JSON below and add to <code>games.json</code>
              </p>
            </div>

            <button
              type="submit"
              className="w-full px-6 py-4 rounded-lg"
              style={{
                background: 'linear-gradient(135deg, #00FFCC, #00CC99)',
                color: '#222222',
                fontFamily: 'VT323, monospace',
                fontSize: '20px',
                fontWeight: 'bold',
                border: 'none',
                cursor: 'pointer'
              }}
            >
              Generate JSON Entry
            </button>
          </form>

          {showOutput && (
            <div className="mt-6">
              <h2 style={{ fontFamily: 'VT323, monospace', fontSize: '20px', color: '#00FFCC' }} className="mb-2">
                Copy this to games.json:
              </h2>
              <pre
                className="p-4 rounded overflow-x-auto"
                style={{
                  backgroundColor: '#000',
                  border: '2px solid #00FFCC',
                  fontFamily: 'VT323, monospace',
                  fontSize: '14px',
                  color: '#00FFCC'
                }}
              >
                {jsonOutput}
              </pre>
              <button
                onClick={copyJSON}
                className="mt-2 px-6 py-2 rounded-lg"
                style={{
                  background: 'linear-gradient(135deg, #00FFCC, #00CC99)',
                  color: '#222222',
                  fontFamily: 'VT323, monospace',
                  fontSize: '18px',
                  fontWeight: 'bold',
                  border: 'none',
                  cursor: 'pointer'
                }}
              >
                Copy to Clipboard
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/game" element={<GamePage />} />
        <Route path="/admin" element={<AdminPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
